import { Component, VERSION } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-turbodash',
    templateUrl: 'app.component.html',
    imports: [RouterOutlet]
})
export class AppComponent {
    readonly isDev = !environment.production;
    readonly angularVersion = VERSION.full;
}
